module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppWrapper', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _c('AppText', [_vm._v(_vm._s(_vm.value))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33824f2a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppHeadingTextBlock/AppHeadingTextBlock.vue
// module id = 04db869adbad66894fec
// module chunks = 89